import { FormType } from '@cod-monorepo/interfaces';
import { StepConfig } from '../../../../shared/types/step-config.type';

export const ItemOrQuantityDomesticStepConfig: StepConfig = {
    type: FormType.ITEM_OR_QUANTITY_DOMESTIC
};
